export default {
  title: 'Endereço de entrega',
  buttons: {
    save: 'Guardar',
  },
};
